<template>
    <div class="container-fluid">
      <div class="page-title">
      <div class="row main-content">
        <div class="col-xxl-4 col-xl-7 col-md-7 col-6">
          <h1>Fees & Charges</h1>        
        </div>
        <div class="col-xxl-8 col-xl-5 col-md-5 col-6 d-flex justify-content-end">
          <NewFees v-if="feeAndRefundStore.currentType === 'fee'" />
          <NewCharge v-else />

        </div>
      </div>
      </div>
      </div>

    <DataTable />
</template>

<script setup>
import DataTable from './dataTable.vue';
import NewFees from './newFees.vue';
import NewCharge from './newCharge.vue';

import { useFeeAndRefundStore } from '@/store/admin/feeAndRefund';

const feeAndRefundStore = useFeeAndRefundStore();
</script>

<style scoped>
.page-title{
  background-color: #e6e9ec !important;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}


.main-content{
  padding: 10px;
  padding-bottom: 20px;
}

@media (max-width:992px) {

  .main-content{
  padding-top: 70px;
}
}
</style>